import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getCreatOrderData = async (params: object) => {
  return await POST({
    url: Api.getCreatOrderData,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getPayAgentList = async (params: object) => {
  return await GET({
    url: Api.getPayAgentList,
    params,
    // headers: {
    //   rpcType: 'dubbo',
    //   'Client-Id': 'iss_courier',
    //   'Content-Type': 'application/json'
    // },
    showError: false
  })
}
export const getOrderInfo = async (params: object) => {
  return await GET({
    url: Api.getOrderInfo,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const creatOrderData = async (params: object, bizCodeHandler, bizCodes) => {
  return await POST({
    url: Api.creatOrderData,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false,
    bizCodeHandler,
    bizCodes
  })
}
export const payOrder = async (params: object) => {
  return await POST({
    url: Api.payOrder,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getCouponList = async (params: object) => {
  return await POST({
    url: Api.couponList,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
